import { ChevronRight } from '@livechat/design-system-icons'
import { Button, Icon } from '@livechat/design-system-react-components'
import { ChevronWrapper } from './ChevronWrapper'
import { css } from '@emotion/react'

const chevronCss = css`
  right: -20px;
`

interface Props {
  handleNext: () => void
}

export const ChevronNext = ({ handleNext }: Props) => {
  return (
    <ChevronWrapper className={chevronCss}>
      <Button
        data-test="chevron-button"
        kind="float"
        onClick={handleNext}
        icon={<Icon source={ChevronRight} />}
      />
    </ChevronWrapper>
  )
}
